<template>
<div class="chapter">
<div class="inner_page">
<p class="block_4"><img alt="Graphical user interface, text, application  Description automatically generated" class="calibre2" src="images/image.jpeg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?f774dc1c